import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { shoesApi } from './service';

const store = configureStore({
  reducer: {
    [shoesApi.reducerPath]: shoesApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(shoesApi.middleware),
});

setupListeners(store.dispatch);

export default store;
